export interface LogRow {
  date: string;
  time: string;
  action: string;
  notes: string;
  verifier: string;
  manager: string;
}

function csvEscape(value: string): string {
  if (value == null) return '';
  const needsQuoting = /[",\n\r]/.test(value);
  const escaped = value.replace(/"/g, '""');
  return needsQuoting ? `"${escaped}"` : escaped;
}

/**
 * Generates a CSV blob from log rows and triggers a browser download.
 * Works entirely client-side — no backend round-trip needed.
 */
export function downloadLogCsv(rows: LogRow[], filename: string): void {
  const header = ['Date', 'Time', 'Action', 'Notes', 'By', 'Manager'];
  const body = rows.map((row) =>
    [row.date, row.time, row.action, row.notes, row.verifier, row.manager].map(csvEscape).join(','),
  );
  const csv = [header.join(','), ...body].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
